module.exports = __webpack_public_path__ + "img/cuarta.c2789f2c.jpg";